'use client'

import { getErrorMessage } from '@/lib/getErrorMessage';

// Brandbook token values (Boostt AI / Blyn design system)
const TOKEN_FONT_FAMILY = 'Onest, Inter, -apple-system, sans-serif';
const TOKEN_BG_APP = '#F7FAFB';
const TOKEN_DANGER_BG = 'rgba(199,58,58,0.10)';
const TOKEN_DANGER_TEXT = '#C73A3A';
const TOKEN_TEXT_TERTIARY = '#6B7B82';
const TOKEN_BRAND_TEAL = '#1B8187';
const TOKEN_WHITE = '#FFFFFF';

export default function GlobalError({ error, reset }) {
  const statusCode = error?.errorCode || error?.status || error?.response?.status;
  const isApiError = !!(statusCode || error?.errorRef || error?.formattedError);
  const isDev = process.env.NODE_ENV === 'development';
  const message = isDev
    ? getErrorMessage(error)
    : isApiError
      ? getErrorMessage(error)
      : 'The page encountered an unexpected error. Please try again.';

  return (
    <html>
      <body style={{
        margin: 0,
        fontFamily: TOKEN_FONT_FAMILY,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: TOKEN_BG_APP,
      }}>
        <div style={{ textAlign: 'center', maxWidth: 440, padding: '2rem' }}>
          <div style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: TOKEN_DANGER_BG,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem',
            fontSize: statusCode ? '1rem' : '2rem',
            fontWeight: 700,
            color: TOKEN_DANGER_TEXT,
          }}>
            {statusCode || '!'}
          </div>

          <h2 style={{ margin: '0 0 0.5rem', fontWeight: 500, fontSize: '1.25rem' }}>
            {statusCode ? `Error ${statusCode}` : 'An error occurred'}
          </h2>

          <p style={{ margin: '0 0 0.5rem', color: TOKEN_TEXT_TERTIARY, fontSize: '0.875rem' }}>
            {message}
          </p>

          <button
            onClick={() => reset()}
            style={{
              padding: '0.5rem 1.5rem',
              backgroundColor: TOKEN_BRAND_TEAL,
              color: TOKEN_WHITE,
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '0.875rem',
            }}
          >
            Try Again
          </button>
        </div>
      </body>
    </html>
  )
}
